import {
   clsx
  ,styled
  ,Box
} from 'external/material'

import useTranslations from 'hooks/translations'
import useAssessment from 'hooks/assessment'

const FillInTheBlanksContainer = styled(Box)(fillInTheBlanksStyles)

export default function FillInTheBlanks ({question}) {

  const {translate} = useTranslations()
  const {assessment, save} = useAssessment()

  const answer = assessment.answers[question.id] || {}

  const {phrases = []} = answer

  function handlePhraseChange (index, phrase) {
    const completed = phrase.length == 0 ? false : phrases.every(({phrase, blanked},i) => i == index || !blanked || phrase.length > 2)
    save({[question.id]: {phrases: {[index]: {phrase: {$set: phrase}}}, completed: {$set: completed}}}, {sendToServer: false})
  }

  const handleOnBlur = () => save({})
	
  return (<FillInTheBlanksContainer className="wrapper">
    <Box className="root">
      {phrases.map(({phrase, blanked}, index) =>
        blanked
          ? (<input
            key={index}
            className={clsx("input", "phrase")}
            type="text"
            value={phrase}
            onChange={e => handlePhraseChange(index, e.target.value)}
            onBlur={handleOnBlur}
            />)
          : (<Box
            key={index}
            className="phrase">{phrase}</Box>)
      )}
    </Box>
  </FillInTheBlanksContainer>)
}


function fillInTheBlanksStyles () {
  return {
    "&.wrapper": {

    },
    "& .root": {
      display: 'flex',
      flexWrap: 'wrap',
      padding: '35px 0',
      fontSize: '12pt',
    },
    "& .phrase": {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginRight: 10,
      '&:last-child': {
        marginLeft: 0
      }
    },
    "& .input": {
        border: 'none',
        borderBottom: 'solid 1px black',
    },
  }
}
